<template>
<div>
    <div class="box time-content">

        <h3>{{ dateDisplay }} <span style="float: right"> {{ staffAttendanceToday }}</span></h3>
        <modal name="view-attendance-details" :width="1100" @before-open="beforeOpen" height="auto" scrollable="true">
            <div class="modal-content">
                <span class="modal-header">Attendance log for {{ name }} </span>
                <div class="container" style="margin-bottom: 3px; width: 1070px;" v-for="calendar in 12" :key="calendar" v-if="calendar <= currentMonth">
                    <div style="float: left; width: 100px; clear: both; ">
                    {{ monthName(calendar) }}:
                    </div>
                    <div style="float: left;">
                        <b-tooltip label="Tooltip top" position="is-top" v-for="index in getDaysInMonth(calendar)" :key="index" style="margin-right: 1px;">
                            <span class="tag is-danger">{{ index }}</span>
                        </b-tooltip>
                    </div>
                </div>
                <!-- hello, world! {{ foo }} {{ userID }} -->
            </div>
        </modal>        

        <div class="columns" v-for="data in dataList" :data.sync="data" v-bind:key="data.key">     
            <div class="column is-one-half">
                <span class="tag is-light is-medium">
                    <strong>{{ data.firstName }} {{ data.lastName }}</strong>
                </span>
            </div>
            <div class="column is-one-quarter">
                <div class="right">
                    <span v-if="data.checkIn" class="tag is-success">
                        {{ increaseCheckInCount }}
                        Checked-in today at {{ data.checkInTime}}
                    </span>
                    <span v-else class="tag is-light">
                        Not checked-in yet
                    </span>
                </div>
            </div>
            <div class="column is-one-quarter">
                <button class='button is-info is-small right' v-on:click="viewAttendanceList(data._id, data.firstName, data.lastName)">View</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            duration: 'daily',
            dateDisplay: '',
            staffCount: 0,
            checkInCount: 0,
            teachers: '',
            result: "",
            errors: [],
            foo: '',
            userID: '',
            name: '',
            currentMonth: 1,
            currentYear: '',
            daysInMonth: 30,
            staffAttendanceData:{
                checkInDate: '',
                checkInTime: '',
                checkInDay: '',
                checkInMonth: '',
                checkInYear: '',
                image: '',
            }
        };
    },
    props: ['dataList'],
    components: {
        DataView,
    },
    computed:{
        staffAttendanceToday: function(){
            return ' Staff attendance for today: ' + this.checkInCount + '/' + this.dataList.length
        },
        increaseCheckInCount: function(){
            this.checkInCount = this.checkInCount + 1;
        }
    },
    methods: {
        getDaysInMonth(month){
            switch(month){
                case 1: case 3: case 5: case 7: case 8: case 10: case 12:
                    return 31;
                    break;
                case 2:
                    return 29;
                    break;
                case 4: case 6: case 9: case 11:
                    return 30;
                    break;
                default:
                    return 30;
                    break;
            }
        },
        displayData(duration){
            this.duration = duration;
        },
        monthName(month){
            switch(month){
                case 1:
                    return "January";
                    break;
                case 2:
                    return "February";
                    break;
                case 3:
                    return "March";
                    break;
                case 4:
                    return "April";
                    break;
                case 5:
                    return "May";
                    break;
                case 6:
                    return "June";
                    break;
                case 7:
                    return "July";
                    break;
                case 8:
                    return "August";
                    break;
                case 9:
                    return "September";
                    break;
                case 10:
                    return "October";
                    break;
                case 11:
                    return "November";
                    break;
                case 12:
                    return "December";
                    break;
                default:
                    return "January";
                    break;
            }
        },
        viewAttendanceList(userID,firstName,lastName){
            console.log("144 data ni")            
            console.log(userID)
            this.$store.commit('UPDATE_USERID',userID)
            this.$store.commit('UPDATE_FIRSTNAME',firstName)
            this.$store.commit('UPDATE_LASTNAME',lastName)

            localStorage.setItem('Attendance_DataList_userID',userID)
            localStorage.setItem('Attendance_DataList_name',firstName + " " + lastName)

            this.goAttendanceDetails();
            //buat sini imin
            //modal docs refer here https://github.com/euvl/vue-js-modal
            //this.$modal.show('view-attendance-details',  { foo: 'bar', userID: userID, name: firstName + " " + lastName });
        },
        goAttendanceDetails(){            
            this.$router.push({
                name: "StaffAttendanceDetails"
            });
        },
        beforeOpen (event) {
            console.log("BeforeOpen 151 event");
            console.log(event)
            //imin sini panggil API utk dapatkan attendance list utk the particular staff
            this.getAttendanceData(event.params.userID)
            console.log(event.params.foo);
            console.log(event.params.userID);
            this.foo = event.params.foo
            this.userID = event.params.userID
            this.name = event.params.name
        },        
        getAttendanceData(userID) {

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.post(process.env.MY_URL + '/api/teachers/attendance', {
                params: {
                    email: localStorage.getItem('email'),
                    sessionID: localStorage.getItem('sessionID'),
                    userID: userID,
                    show: 'overall',
                    year: this.currentYear
                }
            })
            .then(response => {
                console.log("174")
                //console.log(response)
                this.staffAttendanceData = response.data
                console.log(this.staffAttendanceData)
            })
            .catch(e => {
                this.errors.push(e)
                console.log(e)
            })
        },
    },
    created() {
        console.log("60 dataList")
        console.log(this.dataList)
        this.staffCount = this.dataList.length;
        console.log("scount: " + this.staffCount);
        //this.getData()
        var currentDate = new Date();
        //var dateTime = currentDate.getDate() + " " + currentDate.getMonth() + " " + currentDate.getFullYear() + " " + currentDate.getHours() + " " + currentDate.getMilliseconds();
        var month = currentDate.getMonth() + 1;  //since month starts at 0.. january is 0!
        var dayOfWeek = currentDate.getDay();
        this.currentMonth = month;
        this.currentYear = currentDate.getFullYear();

        var dayOfWeekDisplay = "";
        switch (dayOfWeek){
            case 0:
                dayOfWeekDisplay = "Sunday";
                break;
            case 1:
                dayOfWeekDisplay = "Monday";
                break;
            case 2:
                dayOfWeekDisplay = "Tuesday";
                break;
            case 3:
                dayOfWeekDisplay = "Wednesday";
                break;
            case 4:
                dayOfWeekDisplay = "Thursday";
                break;
            case 5:
                dayOfWeekDisplay = "Friday";
                break;
            case 6:
                dayOfWeekDisplay = "Saturday";
                break;
            default:
                dayOfWeekDisplay = "Monday";
                break;
        }

        var monthDisplay = "";
        switch (month){
            case 0:
                monthDisplay = "January";
                break;
            case 1:
                monthDisplay = "February";
                break;
            case 2:
                monthDisplay = "March";
                break;
            case 3:
                monthDisplay = "April";
                break;
            case 4:
                monthDisplay = "May";
                break;
            case 5:
                monthDisplay = "June";
                break;
            case 6:
                monthDisplay = "July";
                break;
            case 7:
                monthDisplay = "August";
                break;
            case 8:
                monthDisplay = "September";
                break;
            case 9:
                monthDisplay = "October";
                break;
            case 10:
                monthDisplay = "November";
                break;
            case 11:
                monthDisplay = "December";
                break;
            default:
                monthDisplay = "January";
                break;
        }

        var dateDisplay = dayOfWeekDisplay + ", " + currentDate.getDate() + " " + monthDisplay + " " + currentDate.getFullYear();
        console.log("dl: " + dateDisplay)
        this.dateDisplay = dateDisplay;
    },
};
</script>

<style lang="css" scoped>
    .modal-content{
        padding: 10px;
        width: 100%;
    }
    .modal-header{
        text-align: center;
        padding: 3px;
        font-size: 16px;
    }
    .columns{
        padding: 0px !important;
        margin: 0px !important;
        height: 40px;
        border: 1px solid #e7e7e7;
        border-radius: 10px;
        margin-bottom: 3px !important;
    }
    .column{
        padding: 3px !important;
    }
    .time-content {
        background-color: white !important;
    }
    .time-tabs {
        margin-bottom: 10px !important;
    }
    .tabs li.is-active a {
        border-bottom-color: #000000;
        color: #7763A9;
        border-bottom: 3px solid;
        font-weight: bold;
    }
    code, pre {
        color: #1b1e21 !important;
        background-color: white !important;
    }
    .right{
        float: right;
    }
</style>
 


// WEBPACK FOOTER //
// src/components/Staff/Attendance/DataList.vue